module.exports = __webpack_public_path__ + "static/media/BRT.2ec7efb5.svg";